(() => {
  const closing = new WeakSet();
  const triggers = new WeakMap();
  const duration = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--motion-duration')) || 0;
  const openDrawer = (dialog, trigger) => {
    if (!dialog || dialog.open) return;
    triggers.set(dialog, trigger);
    dialog.showModal();
    if (duration()) dialog.animate([{transform:'translateX(100%)'},{transform:'translateX(0)'}], {duration:duration(),easing:'cubic-bezier(0,0,.58,1)'});
  };
  document.addEventListener('misa:open-drawer', event => openDrawer(document.getElementById(event.detail.id), event.detail.trigger));
  const closeDrawer = async (dialog) => {
    if (!dialog?.open || closing.has(dialog)) return;
    closing.add(dialog);
    if (duration()) {
      await dialog.animate([{transform:'translateX(0)'},{transform:'translateX(100%)'}], {duration:duration(),easing:'cubic-bezier(0,0,.58,1)'}).finished.catch(() => {});
    }
    dialog.close();
    closing.delete(dialog);
    const trigger = triggers.get(dialog);
    if (trigger?.isConnected) trigger.focus();
  };
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-open-drawer]');
    if (opener) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const dialog = document.getElementById(opener.dataset.openDrawer);
      if (!dialog || dialog.open) return;
      event.preventDefault();
      openDrawer(dialog, opener);
    }
    const closer = event.target.closest('[data-close-drawer]');
    if (closer) closeDrawer(closer.closest('dialog'));
    if (event.target.matches('dialog[open]')) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeDrawer(event.target);
    }
  });
  document.addEventListener('cancel', (event) => {
    if (!event.target.matches('dialog.drawer')) return;
    event.preventDefault();
    closeDrawer(event.target);
  }, true);
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('dialog[open]').forEach(dialog => dialog.close()));
  matchMedia('(min-width:768px)').addEventListener('change', (event) => {
    if (event.matches) document.querySelectorAll('dialog[data-mobile-menu][open]').forEach(closeDrawer);
  });
})();
